import * as React from "react";
import { GraphCommand } from "../interfaces/config";
import { FormGroup, InputGroup, Intent, Checkbox, Tabs, Tab, } from "@focus/focusUI";
import { GrafosObjectsDialog } from "./GrafosObjectsDialog";
import { GrafosElementDialog } from "./GrafosElementDialog";
import { GrafosAxisDialog } from "./GrafosAxisDialog";
import { SelectMenu, CustomLabel } from "@focus/focusUI";
import { GrafosSurfacesDialog } from "./GrafosSurfacesDialog";
export const cleanEmptyValues = (value) => {
    const copyOfValue = [];
    value.forEach((e, i) => {
        copyOfValue[i] = Object.assign({}, e);
        if (e.maxValue === "") {
            copyOfValue[i]["maxValue"] = null;
        }
        if (e.minValue === "") {
            copyOfValue[i]["minValue"] = null;
        }
    });
    return copyOfValue;
};
export class GrafosGraphDialog extends React.PureComponent {
    isSurfaceGraph(content) {
        if (content.config.command === GraphCommand.cuts ||
            content.config.command === GraphCommand.levels ||
            content.config.command === GraphCommand.graph3d) {
            return true;
        }
        return false;
    }
    render() {
        const { content, onUpdate } = this.props;
        const updateField = (fieldName) => (event) => {
            let value = event.target ? event.target.value : event;
            if (fieldName === "axes") {
                value = cleanEmptyValues(value);
            }
            onUpdate(Object.assign(Object.assign({}, content), { config: Object.assign(Object.assign({}, content.config), { [fieldName]: value }) }));
        };
        const updateObjects = (objects) => {
            const value = objects;
            onUpdate(Object.assign(Object.assign({}, content), { data: Object.assign(Object.assign({}, content.data), { objects: value }), config: Object.assign(Object.assign({}, content.config), { objects: value }) }));
        };
        return (React.createElement(Tabs, { id: "GrafosConfig" },
            React.createElement(Tab, { id: "general", title: "general", panel: React.createElement(FormGroup, null,
                    React.createElement(CustomLabel, { text: "Title" },
                        React.createElement(InputGroup, { intent: Intent.PRIMARY, onChange: updateField("title"), value: content.config.title })),
                    React.createElement(CustomLabel, { text: "Type" },
                        React.createElement(SelectMenu, { options: ["Normal", "Polar"], onChange: updateField("type"), value: content.config.type })),
                    React.createElement(CustomLabel, { text: "Show Grid" },
                        React.createElement(Checkbox, { onChange: () => updateField("grid")(!content.config.grid), checked: content.config.grid }))) }),
            React.createElement(Tab, { id: "axis", title: "axis", panel: React.createElement(GrafosAxisDialog, { content: content.config.axes, onUpdate: updateField("axes") }) }),
            this.props.content.config.command === GraphCommand.graph && (React.createElement(Tab, { id: "elements", title: "elements", panel: React.createElement(GrafosElementDialog, { content: content.config, onUpdate: updateField("elements") }) })),
            this.props.content.config.command === GraphCommand.graph && (React.createElement(Tab, { id: "objects", title: "objects", panel: React.createElement(GrafosObjectsDialog, { content: content.config, objects: content.data.objects, onUpdate: updateObjects }) })),
            this.isSurfaceGraph(content) && (React.createElement(Tab, { id: "surfaces", title: "surfaces", panel: React.createElement(GrafosSurfacesDialog, { content: content.config, onUpdate: updateField("surfaces") }) }))));
    }
}
//# sourceMappingURL=GrafosGraphDialog.js.map